export class User {
    id?: string;
    email?: string;
    password?: string;
    token?: string;
    lastName?: string;
    firstName?: string;
    is_confirmed?: boolean;
}
